export default __webpack_public_path__ + "static/media/icon-lock-gray.632f9c15.svg";